// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"VQ","reco":"WQ","products":"XQ"};